import { ABHA_SEO_WIDGET } from '@components/Product/ProductWidget/constants'

export const getAdditionalWidgetProps = (widgetCta: string) => widgetCta === ABHA_SEO_WIDGET ? { modalOpen: true } : {}
